/** @format */

import { Workspace } from './workspace';

export enum WorkspaceModule {
  // AXIO modules
  AXIO_PROSPECT = 'axio-prospect',
  AXIO_CLIENT = 'axio-client',
  AXIO_EQUIPMENT = 'axio-equipment',
  AXIO_INVOICE = 'axio-invoice',
  AXIO_ACTIVITY = 'axio-activity',
  AXIO_MAINTENANCE = 'axio-maintenance',
  AXIO_INTERVENTION = 'axio-intervention',
  AXIO_KAMEO = 'axio-kameo',
  AXIO_INVENTORY = 'axio-inventory',
  AXIO_TEAM = 'axio-team',
  AXIO_KNOWLEDGE_BASE = 'axio-knowledge-base',
  AXIO_SAFETY_AND_ACCESS_CONTROL = 'axio-safety-and-access-control',

  // EBIO modules
  EBIO_REAL_ESTATE_ASSETS = 'ebio-real-estate-assets',
  EBIO_AIR_QUALITY = 'ebio-air-quality',
  EBIO_ENERGY = 'ebio-energy',
  EBIO_VENTILATION_AND_AIR_CONDITIONING = 'ebio-ventilation-and-air-conditioning',
  EBIO_ELEVATOR = 'ebio-elevator',
  EBIO_PARKING_DOOR = 'ebio-parking-door',
  EBIO_FIRE_SAFETY = 'ebio-fire-safety',
  EBIO_SAFETY_AND_ACCESS_CONTROL = 'ebio-safety-and-access-control',
  EBIO_IOT = 'ebio-iot',

  // MY_SESIO modules
  MY_SESIO_CUSTOMER_ACCOUNT = 'my-sesio-customer-account',
  MY_SESIO_ORGANIZATION = 'my-sesio-organization',
  MY_SESIO_REAL_ESTATE_ASSET = 'my-sesio-real-estate-asset',
  MY_SESIO_EQUIPMENT = 'my-sesio-equipment',
  MY_SESIO_USER = 'my-sesio-user',
  MY_SESIO_MAINTENANCE = 'my-sesio-maintenance',
  MY_SESIO_INTERVENTION = 'my-sesio-intervention',
  MY_SESIO_IOT = 'my-sesio-iot',
  MY_SESIO_SETTINGS = 'my-sesio-settings',

  // NETWORK modules
  NETWORK_NODE = 'network-node',
  NETWORK_ROUTER = 'network-router',
  NETWORK_SIM = 'network-sim',
  NETWORK_LORAWAN = 'network-lorawan',
  NETWORK_TELEALARM = 'network-telealarm',
  NETWORK_THING = 'network-thing',
  NETWORK_EQUIPMENT = 'network-equipment',
  NETWORK_LCC_SCENE = 'network-lcc-scene',
  NETWORK_BOILER_ROOM = 'network-boiler-room',
  NETWORK_CUSTOMER = 'network-customer',
  NETWORK_ORGANIZATION = 'network-organization',
  NETWORK_ORG_UNIT = 'network-org-unit',
  NETWORK_REAL_ESTATE_STRUCTURE = 'network-real-estate-structure',
  NETWORK_INTAKE = 'network-intake',
  NETWORK_RIVP = 'network-rivp',
  NETWORK_JOB = 'network-job',
  NETWORK_DEPLOYMENT = 'network-deployment',
  NETWORK_COMPONENT = 'network-component',
  NETWORK_OS_BUILD = 'network-os-build',
  NETWORK_USB_KEY = 'network-usb-key',
  NETWORK_PROVISIONING = 'network-provisioning',
  NETWORK_PROVISIONING_TEMPLATE = 'network-provisioning-template',
  NETWORK_MQTT = 'network-mqtt',
  NETWORK_NOOS = 'network-noos',
  NETWORK_ALERT = 'network-alert',
  NETWORK_MAINTENANCE = 'network-maintenance',
  NETWORK_CONNECTIVITY = 'network-connectivity',
  NETWORK_BANDWIDTH = 'network-bandwidth',
  NETWORK_MIGRATION = 'network-migration',
  NETWORK_USAGE = 'network-usage',
  NETWORK_SYSTEM = 'network-system',
  NETWORK_USER = 'network-user',

  // CONSOLE modules
  CONSOLE_SYSTEM = 'console-system',
  CONSOLE_LOGS = 'console-logs',
  CONSOLE_SERVICE = 'console-service',
  CONSOLE_COMPONENT = 'console-component',
  CONSOLE_APT = 'console-apt',
  CONSOLE_WATCHDOG = 'console-watchdog',
  CONSOLE_GPIO = 'console-gpio',
  CONSOLE_BACNET = 'console-bacnet',
  CONSOLE_BA = 'console-ba',
  CONSOLE_LASER = 'console-laser',
  CONSOLE_DOORS = 'console-doors',
  CONSOLE_FLOORS = 'console-floors',
  CONSOLE_EQUIPMENT = 'console-equipment',
  CONSOLE_ROUTER = 'console-router',
  CONSOLE_LED = 'console-led',
  CONSOLE_USB = 'console-usb',
}

export const WorkspaceModulesMap: Record<Workspace, WorkspaceModule[]> = {
  [Workspace.AXIO]: [
    WorkspaceModule.AXIO_PROSPECT,
    WorkspaceModule.AXIO_CLIENT,
    WorkspaceModule.AXIO_EQUIPMENT,
    WorkspaceModule.AXIO_INVOICE,
    WorkspaceModule.AXIO_ACTIVITY,
    WorkspaceModule.AXIO_MAINTENANCE,
    WorkspaceModule.AXIO_INTERVENTION,
    WorkspaceModule.AXIO_KAMEO,
    WorkspaceModule.AXIO_INVENTORY,
    WorkspaceModule.AXIO_TEAM,
    WorkspaceModule.AXIO_KNOWLEDGE_BASE,
    WorkspaceModule.AXIO_SAFETY_AND_ACCESS_CONTROL,
  ],

  [Workspace.EBIO]: [
    WorkspaceModule.EBIO_REAL_ESTATE_ASSETS,
    WorkspaceModule.EBIO_AIR_QUALITY,
    WorkspaceModule.EBIO_ENERGY,
    WorkspaceModule.EBIO_VENTILATION_AND_AIR_CONDITIONING,
    WorkspaceModule.EBIO_ELEVATOR,
    WorkspaceModule.EBIO_PARKING_DOOR,
    WorkspaceModule.EBIO_FIRE_SAFETY,
    WorkspaceModule.EBIO_SAFETY_AND_ACCESS_CONTROL,
    WorkspaceModule.EBIO_IOT,
  ],

  [Workspace.MY_SESIO]: [
    WorkspaceModule.MY_SESIO_CUSTOMER_ACCOUNT,
    WorkspaceModule.MY_SESIO_USER,
    WorkspaceModule.MY_SESIO_ORGANIZATION,
    WorkspaceModule.MY_SESIO_REAL_ESTATE_ASSET,
    WorkspaceModule.MY_SESIO_EQUIPMENT,
    WorkspaceModule.MY_SESIO_MAINTENANCE,
    WorkspaceModule.MY_SESIO_INTERVENTION,
    WorkspaceModule.MY_SESIO_IOT,
    WorkspaceModule.MY_SESIO_SETTINGS,
  ],

  [Workspace.NETWORK]: [
    WorkspaceModule.NETWORK_NODE,
    WorkspaceModule.NETWORK_ROUTER,
    WorkspaceModule.NETWORK_SIM,
    WorkspaceModule.NETWORK_LORAWAN,
    WorkspaceModule.NETWORK_TELEALARM,
    WorkspaceModule.NETWORK_THING,
    WorkspaceModule.NETWORK_EQUIPMENT,
    WorkspaceModule.NETWORK_LCC_SCENE,
    WorkspaceModule.NETWORK_BOILER_ROOM,
    WorkspaceModule.NETWORK_CUSTOMER,
    WorkspaceModule.NETWORK_ORGANIZATION,
    WorkspaceModule.NETWORK_ORG_UNIT,
    WorkspaceModule.NETWORK_REAL_ESTATE_STRUCTURE,
    WorkspaceModule.NETWORK_INTAKE,
    WorkspaceModule.NETWORK_RIVP,
    WorkspaceModule.NETWORK_JOB,
    WorkspaceModule.NETWORK_DEPLOYMENT,
    WorkspaceModule.NETWORK_COMPONENT,
    WorkspaceModule.NETWORK_OS_BUILD,
    WorkspaceModule.NETWORK_USB_KEY,
    WorkspaceModule.NETWORK_PROVISIONING,
    WorkspaceModule.NETWORK_PROVISIONING_TEMPLATE,
    WorkspaceModule.NETWORK_MQTT,
    WorkspaceModule.NETWORK_NOOS,
    WorkspaceModule.NETWORK_ALERT,
    WorkspaceModule.NETWORK_MAINTENANCE,
    WorkspaceModule.NETWORK_CONNECTIVITY,
    WorkspaceModule.NETWORK_BANDWIDTH,
    WorkspaceModule.NETWORK_MIGRATION,
    WorkspaceModule.NETWORK_USAGE,
    WorkspaceModule.NETWORK_SYSTEM,
    WorkspaceModule.NETWORK_USER,
  ],

  [Workspace.CONSOLE]: [
    WorkspaceModule.CONSOLE_SYSTEM,
    WorkspaceModule.CONSOLE_LOGS,
    WorkspaceModule.CONSOLE_SERVICE,
    WorkspaceModule.CONSOLE_COMPONENT,
    WorkspaceModule.CONSOLE_APT,
    WorkspaceModule.CONSOLE_WATCHDOG,
    WorkspaceModule.CONSOLE_GPIO,
    WorkspaceModule.CONSOLE_BACNET,
    WorkspaceModule.CONSOLE_BA,
    WorkspaceModule.CONSOLE_LASER,
    WorkspaceModule.CONSOLE_DOORS,
    WorkspaceModule.CONSOLE_FLOORS,
    WorkspaceModule.CONSOLE_EQUIPMENT,
    WorkspaceModule.CONSOLE_ROUTER,
    WorkspaceModule.CONSOLE_LED,
    WorkspaceModule.CONSOLE_USB,
  ],
};
